import { createContext, useContext, useEffect, useState } from "react";
import { translations, LANGS, RTL_LANGS } from "./translations";
import { extra } from "./translationsExtra";
import { sections } from "./sections";
import { world } from "./world";
import { brand } from "./brand";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("fba_lang") || "en");

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("fba_lang", l);
  };

  useEffect(() => {
    const dir = RTL_LANGS.includes(lang) ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const t = {
    ...(translations[lang] || translations.en),
    ...(extra[lang] || extra.en),
    ...(sections[lang] || sections.en),
    world: world[lang] || world.en,
    brand: brand[lang] || brand.en,
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, langs: LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
